import React from "react"
import {Dialog, DialogTitle, DialogContent, Button, DialogActions} from "@mui/material";
import {Action} from "../../../models";
import { Trans } from "@lingui/macro";

interface MarkActionAsDoneProps {
    onClose: () => void
    submit: () => void
    action: Action
}

interface MarkActionAsDoneState {

}

export class MarkActionAsDone extends React.Component<MarkActionAsDoneProps, MarkActionAsDoneState>
{
    render(){
        return (
            <Dialog open={true} onClose={this.props.onClose}>
                <DialogTitle>
                    <Trans id={"mark-action-as-done.title"}>
                        Contrassegna azione come eseguita
                    </Trans>
                </DialogTitle>
                <DialogContent>
                    <Trans id={"mark-action-as-done.body"}>
                        Premendo sul tasto conferma l'azione {this.props.action.name} verrà contrassegnata come eseguita. Quest'operazione non è reversibile,
                    </Trans>
                </DialogContent>
                <DialogActions sx={{pr:2}}>
                    <Button onClick={this.props.onClose}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 1,
                                width: 100
                            }}
                            disableElevation>
                        <Trans id={"mark-action-as-done.close-button"}>
                            Annulla
                        </Trans>
                    </Button>
                    <Button onClick={this.props.submit}
                            variant="contained"
                            sx={{
                                backgroundColor: 'secondary.main',
                                color: 'white',
                                mr: 1,
                                textTransform: "none",
                                width: 100
                            }}
                    >
                        <Trans id={"mark-action-as-done.confirm-button"}>Conferma</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
